<template>
    <div style="text-align: left">
        <el-link v-if="isCustomProtocol" :href="_src" target="_blank" type="primary"><i class="el-icon-link"></i>查看</el-link>
        <iframe v-else ref="extend-menu" id="thirdIframe" frameborder="0" scrolling="auto" :src="_src" class="docframe width-p100" seamless :style="{ height: this.containerHeight }"></iframe>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// 用于自定义菜单节点
export default {
    name: `ExtendMenu`,
    data() {
        return {
            title: `第三方页面`,
            token: this.$route.query.token,
            src: this.$route.query.source,
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: undefined
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
    },
    mounted() {
        // this.loadSurgeryInfo()
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        containerHeight() {
            return `${this.screenHeight - 120}px`
        },
        isCustomProtocol() {
            return !_.startsWith(this.src, `http`)
        },
        _src() {
            if (!this.currentUser) return ``
            let r = this.src + `?1=1`
            _.forEach(this.$route.query, (value, key) => {
                if (key == `source`) return
                if (value == `@username`) {
                    r += `&${key}=${this.currentUser.dic_worker_id}`
                } else if (value == `@staffname`) {
                    r += `&${key}=${this.currentUser.dic_worker_name}`
                } else if (`${value}`.indexOf(`@`) == 0) {
                    r += `&${key}=${(this.surgeryInfo && this.surgeryInfo[value.replace(`@`, ``)]) || ``}`
                } else {
                    r += `&${key}=${value}`
                }
            })
            return r
        }
    },
    methods: {
        loadSurgeryInfo() {
            if (!this.surgeryId) return
            var that = this
            return new Promise((resolve, reject) => {
                if (this.surgeryInfo && this.surgeryInfo.id == this.surgeryId) {
                    resolve(this.surgeryInfo)
                } else {
                    let req1 = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                    req1.then(data => {
                        let extrDatas = _.reduce(data.extra_datas, function(result, value, index) {
                            let flag = that.isjson(value.DataValue)
                            if (value.DataValue != `` && flag == true) {
                                result[value.DataKey] = value.DataExtraValue
                            } else {
                                result[value.DataKey] = value.DataValue
                            }
                            return result
                        }, {})

                        this.surgeryInfo = Object.assign(data, extrDatas)
                        resolve(this.surgeryInfo)
                    }).catch(e => {
                        console.log(e)
                        resolve({})
                    })
                }
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSurgeryInfo()
            this.src = newUrl.query.source
        }
    }
}
</script>

<style scoped>
.docframe {
    border: none;
    background: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Menu/ExtendMenu.vue